module.exports = __webpack_public_path__ + "img/swap-image.b7158aeb.png";